<mat-drawer
  class="flex flex-grow"
  [ngStyle]="{
    width: drawerWidth,
    '--header-height': toolbarSubtitle ? '100px' : '64px',
    '--toolbar-title-background': toolbarTitleBackground || 'inherit',
    '--toolbar-title-color': toolbarTitleColor || toolbarTitleTextColor || 'inherit',
    '--toolbar-title-font-family': toolbarTitleFontFamily ? '\'' + toolbarTitleFontFamily + '\'' : 'inherit',
    '--toolbar-title-font-size': toolbarTitleFontSize || 'inherit',
    '--toolbar-title-font-weight': toolbarTitleFontWeight || 'inherit',
    '--toolbar-subtitle-color': toolbarSubtitleColor || 'inherit',
    '--toolbar-subtitle-font-family': toolbarSubtitleFontFamily ? '\'' + toolbarSubtitleFontFamily + '\'' : 'inherit',
    '--toolbar-subtitle-font-size': toolbarSubtitleFontSize || 'inherit',
    '--toolbar-subtitle-font-weight': toolbarSubtitleFontWeight || 'inherit'
  }"
  [opened]="isDrawerOpen$ | async"
  mode="push"
  position="end"
>
  <mat-toolbar class="cdw-drawer-header" [class.has-subtitle]="toolbarSubtitle" [class.no-border]="hideHeaderBorder">
    <!-- If subtitle exists -->
    <ng-container *ngIf="toolbarSubtitle; else noSubtitle">
      <div class="flex flex-col justify-between h-full w-full">
        <!-- Top row -->
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-row items-center min-w-0">
            <lib-cdw-icon class="drawer-icon flex-shrink-0" [icon]="toolbarIconName"></lib-cdw-icon>
            <span class="title truncate">{{ toolbarTitle }}</span>
          </div>
          <button mat-icon-button class="flex-shrink-0 ml-2" (click)="closeParentDrawer()">
            <lib-cdw-icon class="close-drawer-icon" icon="close"></lib-cdw-icon>
          </button>
        </div>

        <!-- Subtitle -->
        <span class="subtitle">{{ toolbarSubtitle }}</span>
      </div>
    </ng-container>

    <!-- No subtitle -->
    <ng-template #noSubtitle>
      <div class="flex row items-center justify-between flex-grow">
        <div class="flex items-center select-none cursor-default min-w-0">
          <lib-cdw-icon class="drawer-icon flex-shrink-0" [icon]="toolbarIconName"></lib-cdw-icon>
          <span class="title truncate">{{ toolbarTitle }}</span>
        </div>
        <button mat-icon-button class="flex-shrink-0 ml-2" (click)="closeParentDrawer()">
          <lib-cdw-icon class="close-drawer-icon" icon="close"></lib-cdw-icon>
        </button>
      </div>
    </ng-template>
  </mat-toolbar>

  <ng-content></ng-content>
</mat-drawer>
